export default __webpack_public_path__ + "static/service-3-1b9ab245ce4488a3d850505612d16122.jpg";